<template>
	<div>
		<ticket-message-action
			:is-visible="rateTicketVisible"
			:ratingOnly="true"
			v-on:hide-ticket-message-action="rateTicketVisible = false"
			v-on:ticket-rated="onRateComplete"
			:ticket="ticketForRate"
		/>
		<md-dialog :md-active.sync="showChatMessagesWindowDialog" :md-click-outside-to-close="false">
			<chatMessagesWindow
				:dataObj="ticketForMessage"
				:initialMessage="!ticketForMessage ? null : {
					number: ticketForMessage.ticketNumber,
					title: ticketForMessage.ticketTitle,
					date: formatDate(ticketForMessage.date, 'short2'),
					text: ticketForMessage.text
				}"
				:directSend="true"
				@closeChatMessagesWindow="showChatMessagesWindowDialog = false"
				@messageSent="onMessageSent"
			></chatMessagesWindow>
		</md-dialog>
		<close-ticket
			v-bind:is-visible="showCloseTicketDialog"
			v-on:hide-close-dialog="showCloseTicketDialog = false; createTicket();"
			v-on:ticket-closed="update"
			:ticket="ticketToClose"
			:allowEmpty="true"/>
		<md-dialog class="last-message-dialog" :md-active.sync="showExpandMessageDialog">
			<md-toolbar class="md-primary"><h3>{{ expandMessageItem ? `${formatDate(expandMessageItem.date, "long")} ${expandMessageItem.author}` : ""}}</h3></md-toolbar>
			<div class="last-message-dialog-text"><pre class="dialog-pre">{{expandMessageItem ? expandMessageItem.text : ""}}</pre></div>
			<md-dialog-actions>
				<md-button class="md-primary" @click="showExpandMessageDialog = false">Закрыть</md-button>
			</md-dialog-actions>
		</md-dialog>

		<md-dialog :md-fullscreen="false" :md-active.sync="selectTitleDialog" class="md-layout-item md-xsmall-size-100 md-small-size-90 md-large-size-50 md-xlarge-size-50 title-dialog">
			<md-toolbar class="md-primary" >
				<h3>Создание новой или работа с текущей заявкой</h3>
			</md-toolbar>
			<md-card class="title-card">
				<table class="s-table">
					<thead class="s-table-head table-header-filled">
						<th class="table-header" style="width: 1%; text-align: center;">Новая заявка</th>
						<th class="table-header" style="width: 1%">Тема</th>
						<th class="table-header">Текущая заявка</th>
						<th class="table-header" colspan="2" style="width: 1%; text-align: center;"></th>
					</thead>
					<tbody>
							<tr v-for="item in activeTicketInfo" v-bind:key="item.titleNpp">
								<td>
								<md-button :disabled="item.ticketId != -1" class="md-primary md-raised md-dense" @click="createNewTicket(item)">Создать</md-button>
							</td>
							<td>{{ item.titleName }}</td>
							<td>{{item.ticketNumber ? `№${item.ticketNumber}(${item.ticketCreateTime.slice(0, 16)}) ${item.ticketMessage}` : item.ticketMessage}}</td>
							<td>
								<md-button v-if="item.ticketId != -1" class="md-primary md-raised md-dense" md-theme="green" @click="closeTicket(item)">Закрыть заявку (вопрос решён)</md-button>
							</td>
							<td>
								<md-button
									v-if="item.ticketId != -1"
									class="md-primary md-raised md-dense"
									@click="openTicket(item.ticketNumber, item.ticketId)"
									>
									Показать
								</md-button>
							</td>
						</tr>
					</tbody>
				</table>
			</md-card>
			<md-dialog-actions>
				<md-button class="md-accent md-raised md-dense" @click="selectTitleDialog = false">Отмена</md-button>
			</md-dialog-actions>
		</md-dialog>
		<md-dialog :md-active.sync="activeTicketWarn">
			<md-card>
				<md-card-header>
					<div class="md-title">У вас есть активная заявка № {{activeTicketInfo.number}} от {{activeTicketInfo.createTime}}</div>
				</md-card-header>
				<md-card-content>
					<div><b>Тема</b>: {{ activeTicketInfo.title }}</div>
					<div>{{ activeTicketInfo.msg }}</div>
					<br>
					<div class="md-title1">Открыть активную заявку для редактирования?</div>
				</md-card-content>
				<md-card-actions>
					<md-button @click="activeTicketWarn = false; openTicket(activeTicketInfo.number, activeTicketInfo.ticketId)" class="md-primary">Открыть</md-button>
					<md-button @click="activeTicketWarn = false" class="md-accent">Закрыть</md-button>
				</md-card-actions>
			</md-card>
		</md-dialog>
		<!-- модальное окно для изменения темы заявки -->
		<md-dialog :md-active.sync="showTitleChangeDialog" :md-click-outside-to-close="false">
				<titleWindow :dataObj="{ticket: ticketForModal}"
								v-if="ticketForModal"
								@closeTitleWindow="closeTitleWindow"
				></titleWindow>
		</md-dialog>

		<!--Таблица с v-model -->
		<!--если есть пользователи сайта аптеки-->
		<md-card class="table-card">
			<md-toolbar id="tickets-table-toolbar" class="md-dense">
				<div class="md-toolbar-section-start">
					<div class="md-layout md-gutter md-alignment-center-left" style="margin-top: 4px;width:100%">
						
						<div class="md-layout-item md-size-15" style="min-width: 150px">
							<md-button
								tabindex="-1"
								class="md-dense md-raised md-primary md-theme-default"
								@click="createTicket"
								:disabled="newTicketInProcess">
									Создать заявку
							</md-button>
						</div>

						<!--	фильтр по пользователю аптеки	-->

						<div v-if="hasSiteUsers()" class="md-layout-item md-small-size-25 md-medium-size-25 md-large-size-20 md-xlarge-size-20">
							<md-field>
								<label v-if="fltUsersOfApteka.length === 0">Все пользователи</label>
								<label v-else>Пользователь</label>
								<md-select
												v-model="fltUsersOfApteka"
												id="FilterUsersOfApteka"
												md-dense
												style="margin-right: -10px;"
												@md-selected="onSelectUserOfApteka()"
												multiple
								>
										<md-option
														v-for="user in SITEUSERS"
														:value="user.id"
														:key="user.id"
										>{{user.fullName}}
										</md-option>
								</md-select>
								<md-button
												tabindex="-1"
												class="md-icon-button md-dense"
												@click="clearFltUsersOfApteka"
												v-if="fltUsersOfApteka.length !== 0"
								>
										<md-icon>clear</md-icon>
								</md-button>
							</md-field>
						</div>

						<!--	контекстный поиск	-->
						<div class="md-layout-item md-size-25">
								<md-field md-clearable>
										<label style="font-size: 0.7rem;">Все поля кроме Статус и Обновлено</label>
										<md-input
														placeholder="Поиск..."
														v-model.lazy.trim="fltClients"
														id="FilterClients"
														@input="onInputFilter()"
														md-dense
										>
										</md-input>
								</md-field>
						</div>
						<!--	кнопка обновить данные	-->
						<div class="md-layout-item md-size-5" style="padding-left: 0px;">
								<md-button
												class="md-icon-button"
												id="tickets-update-button"
												@click="clickUpdate"
												:disabled="loading"
								>
										<md-icon>refresh</md-icon>
										<md-tooltip md-direction="bottom" md-delay="500">Обновить данные</md-tooltip>
								</md-button>
						</div>
					</div>
				</div>
			</md-toolbar>
			<table class="s-table s-table-bordered">
				<thead class="s-table-head">
					<th class="table-header" style="width: 1%"></th>
					<th class="table-header" style="width: 1%; text-align: center;">№</th>
					<th class="table-header" style="width: 1%">Тема / Дата</th>
					<th class="table-header" style="width: 35%">
						Заявка
						<label class="header-radio"><input @change="onSelectState()" type="radio" v-model="fltStates" v-bind:value="''"/>Все</label>
						<label class="header-radio" v-for="item in TICKETSSTATES" :key="item.name" :value="item.name">
							<input @change="onSelectState()" type="radio" v-model="fltStates" v-bind:value="item.name"/>
							<span v-bind:class="{'blinking-item': fltStates == item.name}" :style="`border-radius: 4px; background-color:${calcStateColor(item.name)};`">{{item.name}}</span>
						</label>
					</th>
					<th class="table-header" style="width: 25%">Ответ</th>
					<th class="table-header" style="width: 1%; text-align: center;">Смотрено</th>
					<th class="table-header" style="width: 1%" v-if="hasSiteUsers() && inputDataContainsUser()">Пользователь</th>
				</thead>
				<tbody>
					<tr
						v-for="item in localInputData"
						v-bind:key="item.npp"
						:style="`background-color:${calcStateColor(item.stateName)};`"
						@mouseenter="hoverTicketNpp = item.npp"
						@mouseleave="hoverTicketNpp = 0"
					>
						<td class="no-padding-td">
							<md-menu>
								<md-button md-menu-trigger class="md-raised open-button" v-bind:class="{'md-accent': calcTicketChanges(item.npp)}">Действие</md-button>
								<md-menu-content style="max-width: 500px">
									<md-menu-item @click="openTicket(item.number, item.npp)">Показать заявку (добавить новое сообщение)</md-menu-item>
									<md-menu-item :disabled="item.stateName == 'Решена'" @click="closeTicket({ticketId: item.npp, ticketNumber: item.number, titleName: item.title}, false)">Закрыть заявку</md-menu-item>
									<md-menu-item :disabled="item.stateName != 'Решена'" @click="rateTicket(item)">Поставить оценку</md-menu-item>
								</md-menu-content>
							</md-menu>
						</td>
						<td style="text-align: right" class="text-td">
							{{ item.number }}
							<md-icon style="color:#FF5252; padding-left:10px;" v-if="calcIsResponseRequestTickets(item.npp)">new_releases</md-icon>
							<md-tooltip md-direction="bottom" md-delay="500">Сотрудник Кверти запросил ответ</md-tooltip>
						</td>
						<td class="text-td">
							<span>{{ item.title }}</span>
							<br>{{ formatDate(item.messageDate, "short2") }}
						</td>
						<td class="text-td">
							<div class="message-button" @click.prevent="expandMessage(item, 'first')">
								<pre class="table-pre">{{ formatMessage(item.message) }}</pre>
							</div>
						</td>
						<td class="text-td">
							<div class="stars-container" v-if="item.rating > 0">
								<span>
									<md-icon v-for="i in item.rating" :key="i" class="stars-icon">star</md-icon>
								</span>
								<span v-if="item.rating < 5" >
									<md-icon v-for="i in 5 - item.rating" :key="i" class="stars-icon">star_border</md-icon>
								</span>
							</div>
							<div v-if="item.lastMessageShort.length != 0" class="message-button" @click.prevent="expandMessage(item, 'last')">
								{{ formatLastMessageMeta(item) }}
								<br>
								<pre class="table-pre">{{ item.lastMessageShort }}</pre>
							</div>
						</td>
						<td>
							<span class="badget-item">
								<md-switch v-bind:value="calcTicketChanges(item.npp)" v-bind:disabled="item.switchDisabled || item.lastMessageShort.length == 0" md-theme="green" v-bind:class="{'md-primary': !calcTicketChanges(item.npp) && item.lastMessageShort.length != 0}" v-on:change="seenSwitch(item)" style="margin: auto; padding-left:10px"/>
								<div class="blinking-item">
									<md-badge :md-content="calcNewMessagesCount(item.npp)" v-if="calcTicketChanges(item.npp)">&nbsp;</md-badge>
								</div>
							</span>
						</td>
						<td v-if="hasSiteUsers() && inputDataContainsUser()" class="text-td">
							{{ item.userFullName }}
						</td>
					</tr>
				</tbody>
			</table>
		</md-card>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";
	import {debounce} from "../utilities/utilities.js";
	import titleWindow from "./titleWindow";
	import CloseTicket from "./closeTicket.vue";
	import chatMessagesWindow from "./chatMessagesWindow.vue";
	import ticketMessageAction from "./ticketMessageAction.vue";

	export default {
		components: {titleWindow, CloseTicket, chatMessagesWindow, ticketMessageAction},
		name: "Tickets",
		inject: [
			"setCountPagination",
			"getRowsPerPage",
			"getCurrentPage",
			"setCurrentPage",
			"getLoading",
			"setLoading"
		],
		data: () => ({
			url_data: "data/GetClientTicketsPagination",
			tableHeight: 700, //сделал обычным свойством, т.к. вычисляемое свойство глючит при переходе с внешней панели вкладок
			isMounted: false,
			hoverTicketNpp: 0, //npp заявки на которую наведена мышка
			ticketForModal: null,
			showTitleChangeDialog: false,
			activeTicketWarn: false,
			activeTicketInfo: [],
			ticketMap: {},
			ticketsTitlesInfo: [],
			selectTitleDialog: false,
			titleForNewTicket: null,
			
			showExpandMessageDialog: false,
			expandMessageItem: null,

			ticketToClose: null,
			showCloseTicketDialog: false,
			
			showChatMessagesWindowDialog: false,
			ticketForMessage: null,

			rateTicketVisible: false,
			ticketForRate: null

		}),
		methods: {
			onRateComplete() {
				this.update();
			},
			rateTicket(item) {
				this.ticketForRate = {
					ticketId: item.npp,
					ticketNumber: item.number,
					ticketTitle: item.title,
					ticketTitleId: -1
				};
				this.rateTicketVisible = true;
			},
			onMessageSent() {
				this.showChatMessagesWindowDialog = false;
				this.$store.dispatch('SET_TICKETLASTUPDATETIME', {
							ticketNpp: this.ticketForMessage.ticketId,
							clientNpp: this.CURRENTAPTEKA.npp,
							userId: this.userId
						});
				
				this.ticketForMessage = null;
				this.update();
			},
			addNewMessage(item) {
				this.ticketForMessage = {
					ticketId: item.npp,
					ticketNumber: item.number,
					ticketState: item.state,
					ticketTitle: item.title,
					clientId: this.CURRENTAPTEKA.npp,
					userId: this.CURRENTUSER.userId,
					idApt: this.CURRENTAPTEKA.idapt,
					text: item.message,
					date: item.messageDate,
					newMessage: ""
				}
				this.showChatMessagesWindowDialog = true;
			},
			changeFltState(value) {
				this.fltStates = value;
			},
			onSelectTitle(item) {
				this.titleForNewTicket = item.titleNpp;
			},
			createTicket() {
				if (this.skipCreateDialog) {
					this.skipCreateDialog = false;
					return;
				}
				this.$http.get("data/GetTicketsTitlesInfo", {
                    params: { npp: this.CURRENTAPTEKA.npp }
				}).then(resp => {
					this.activeTicketInfo = resp.body;
					for (let i = 0, cnt = this.activeTicketInfo.length; i < cnt; i++) {
						this.ticketMap[this.activeTicketInfo[i].titleNpp] = this.activeTicketInfo[i];
					}
					this.titleForNewTicket = null;
					this.selectTitleDialog = true;
				})
			},
			createNewTicket(item) {
				if (item.ticketId == -1 ) {
					this.$store.dispatch("ADD_TABB", {
								id: this.LAST_NUMBER,
								Name: "Новая заявка",
								Value: "messages",
								Route: "messages?tn=0",
								Pagination: false
							});
					this.$store.dispatch("SETNEWTABTICKETTITLEA", {
									titleName: item.titleName,
									titleId: item.titleNpp
								});
					this.$store.dispatch("INCREASE_LAST_NUMBER");
                    this.$store.dispatch(
                        "SET_SUPPORTCURRENTTABROUTE",
                        "messages?tn=0"
                    );
                    this.$router.push({ path: "/support/messages", query: { tn: 0 } });
				}
			},
			closeTicket(item, showCreateDialog = true) {
				this.skipCreateDialog = !showCreateDialog;
				this.ticketToClose = item;
				this.showCloseTicketDialog = true;
			},
			openSelectedTicket() {
				var t = this.ticketMap[this.titleForNewTicket];
				this.openTicket(t.ticketNumber, t.ticketId);
			},
			openTicket(num, npp) {
				if (this.OPENEDTICKETSTABS.includes(npp)) {
					this.$store.dispatch(
						"SET_SUPPORTCURRENTTABROUTE",
						"messages?tn=" + npp
					);
					this.$router.push({path: "/support/messages", query: {tn: npp}});
				} else {
					this.$store.dispatch("ADD_TABB", {
						id: this.LAST_NUMBER,
						Name: "Заявка " + num,
						Value: "messages",
						Route: "messages?tn=" + npp,
						Pagination: false,
						Num: npp,
						Number: num
						// Npp: npp
					});
					this.$store.dispatch("INCREASE_LAST_NUMBER");
					this.$store.dispatch("ADD_OPENEDTICKETSTABS", npp);
					this.$store.dispatch(
						"SET_SUPPORTCURRENTTABROUTE",
						"messages?tn=" + npp
					);
					this.$router.push({path: "/support/messages", query: {tn: npp}});
				}

				//убираем заявку из массива непросмотренных
				if (this.TICKETSWITHCHANGES.find(x => x.npp === npp)) {
					let index = this.TICKETSWITHCHANGES.findIndex(x => x.npp === npp);
					this.$store.dispatch('REMOVE_TICKETSWHITHCHANGES', index);
				}

				//убираем заявку из массива USERTICKETSWITHCHANGES
				this.$store.dispatch('REMOVE_USERTICKETSWITHCHANGES', num);

				//обновляем в таблице HistoryMessages время последнего просмотра заявки
				//this.$store.dispatch('SET_TICKETLASTUPDATETIME', {ticketNpp: npp, clientNpp: this.CURRENTAPTEKA.npp});
				//обновляем last_update_time таблицы HistoryClientTickets для запуска проверки наличия изменений,
				// которые снимут пометку непросмотрености заявки если одновременно данная заявка открыта в другом браузере
				//this.$store.dispatch('SET_LASTUPDATETIMEFROMSERVER', {clientNpp: this.CURRENTAPTEKA.npp});
			},
			setParentCountPagination() {
				let row_min = 0;
				let data_count = 0;
				let row_max = 0;
				let ln = this.localInputData.length;
				if (ln > 0) {
					row_min = this.localInputData[0]["rowNum"];
					data_count = this.localInputData[0]["maxRow"];
					row_max = this.localInputData[ln - 1]["rowNum"];
				}
				this.setCountPagination([row_min, row_max, data_count]);
			},
			update() {
				//   console.log("tickets update()");
				//   console.log("rowsPerPage = " + this.getRowsPerPage());
				//   console.log("currentPage = " + this.getCurrentPage());
				if (this.loading) {
					return;
				}
				this.loading = true;
				this.$http
					.get(this.url_data, {
						params: this.paramsData
					})
					.then(
						response => {
							this.localInputData = Array.from(response.body);
						},
						() => {
							this.$store.dispatch("showSnackBar", {
								snackText: "Ошибка получения списка заявок"
							});
						}
					)
					.finally(() => {
						this.setParentCountPagination();
						this.loading = false;
						//для корректного рассчета ширины столбцов шапки таблицы
						this.windowsResize();
					});
			},
			clearLoading() {
				this.loading = false;
			},
			clearFltStates() {
				this.fltStates = "";
			},
			clearFltClients() {
				this.fltClients = "";
			},
			clearFltUsersOfApteka() {
				this.fltUsersOfApteka = [];
			},
			clickUpdate() {
				this.setCurrentPage(1);
				this.update();
			},
			calcTicketChanges(ticketNpp) {
				if (this.TICKETSWITHCHANGES.find(x => x.npp === ticketNpp)) {
					return true;
				}
				return false;
			},
			calcStateColor(stateName) {
				switch (stateName) {

					// case "Новая":
					// 	return "darkred";
					// case "В работе":
					// 	return "goldenrod";
					// case "Закрыта":
					// 	return "darkgreen";

					// case "Новая":
					// 	return "red";
					// case "В работе":
					// 	return "yellow";
					// case "Закрыта":
					// 	return "green";

					case "Новая":
						return "#FFD7D7";
					case "В работе":
						return "#FFFFD7";
					case "Закрыта":
						return "#D7FFD7";
					case "Решена":
						return "#D7FFD7";
					default:
						return 'white';
					// case "Новая":
					// 	return "#FFEBEB";
					// case "В работе":
					// 	return "#FFFFEB";
					// case "Закрыта":
					// 	return "#EBFFEB";
				}
			},
			calcNewMessagesCount(ticketNpp) {
				let ticketObj = this.TICKETSWITHCHANGES.find(x => x.npp === ticketNpp);
				return ticketObj ? ticketObj.newMessagesCount : 0;
			},
			// calcTicketsWithUserMessages(ticketNpp) {
			// 	if (this.TICKETSWITHUSERMESSAGES.includes(ticketNpp)) return true;
			// 	return false;
			// },
			calcIsResponseRequestTickets(ticketNpp) {
				return this.ISRESPONSEREQUESTTICKETS.map(x => x.npp).includes(ticketNpp);
			},
			windowsResize() {
				window.dispatchEvent(new Event('resize'));
			},
			calcTableHeight() {
				let pageHeight = document.documentElement.clientHeight;
				let updateTimeToolbarHeight = document.getElementById("update-time-toolbar") ?
					document.getElementById("update-time-toolbar").clientHeight : 0;
				let toolbarHeight = document.getElementById("application-toolbar")
					.clientHeight;
				let tabsPanel = document.getElementById("second-tabs-panel");
				let tabsPanelHeight = tabsPanel.clientHeight ? tabsPanel.clientHeight : 48;
				let ticketsTableToolbarHeight = document.getElementById(
					"tickets-table-toolbar"
				).clientHeight;
				let tableHead = document.querySelector(".s-table-head");
				let tableHeadheight = tableHead.clientHeight ? tableHead.clientHeight : 56;
				let paddingMarginHeight = 60;

				let newsMarquee = document.getElementById('news-marquee');
				let newsMarqueeHeight = newsMarquee ? newsMarquee.clientHeight * 2 : 0;

				// console.log('pageHeight = ' + pageHeight);
				// console.log('toolbarHeight = ' + toolbarHeight);
				// console.log('tabsPanelHeight = ' + tabsPanelHeight);
				// console.log('ticketsTableToolbarHeight = ' + ticketsTableToolbarHeight);
				// console.log('tableHeadheight = ' + tableHeadheight);
				// console.log('paddingMarginHeight = ' + paddingMarginHeight);
				// console.log('Итого = '  + (pageHeight - toolbarHeight - tabsPanelHeight - ticketsTableToolbarHeight - tableHeadheight - paddingMarginHeight));

				this.$store.dispatch("setApp", {
					tableHeight:
						pageHeight -
						updateTimeToolbarHeight -
						toolbarHeight -
						tabsPanelHeight -
						ticketsTableToolbarHeight -
						tableHeadheight -
						paddingMarginHeight -
						newsMarqueeHeight
				});
				this.tableHeight = this.$store.state.app.tableHeight;
				// this.tableHeight = pageHeight - updateTimeToolbarHeight - toolbarHeight - tabsPanelHeight - paddingMarginHeight;
			},
			onSelectState() {
				if (this.isMounted) {
					this.clickUpdate();
				}
			},
			onSelectUserOfApteka() {
				if (this.isMounted) {
					this.clickUpdate();
				}
			},
			onInputFilter() {
				if (this.isMounted) {
					this.debounceClickUpdate();
				}
			},
			changeTicketTitle(ticket) {
				this.ticketForModal = ticket;
				this.showTitleChangeDialog = true;
			},
			closeTitleWindow(title = '') {
				//если title не передан, значит это событие сгенерировано по кнопке отмена
				if (title) {
					const ticket = this.localInputData.find(ticket => +ticket.npp === +this.ticketForModal.npp);
					if (ticket)
						ticket.title = title;
					else
						console.error(`В localInputData не найден ticket c npp = ${this.ticketForModal.npp}`);
				}
				this.showTitleChangeDialog = false;
				this.ticketForModal = null;
			},
			inputDataContainsUser() {
				return this.localInputData.find(t => t.userFullName != '');
			},
			formatDate(jsonDate, format) {
				let d = new Date(jsonDate);
				if (format == "normal") {
					return d.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'}).replace(',', '');
				}
				else if (format == "short") {
					return d.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: '2-digit'});
				}
				else if (format == "short2") {
					return d.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'});
				}
				else if (format == "long") {
					return d.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).replace(',', '');
				}
			},
			formatLastMessageMeta(item) {
				return `${this.formatDate(item.lastMessageDate, "normal")} ${item.lastMessageAuthor}:`;
			},
			formatMessage(item) {
				const len = 100;
				if (item.length > len) {
					return item.substring(0, len) + "...";
				}
				return item;
			},
			expandableLastMessage(item) {
				return item.lastMessage.length > 100;
			},
			expandMessage(item, msgType) {
				if (msgType == "last") {
					this.expandMessageItem = {
						author: item.lastMessageAuthor,
						date: item.lastMessageDate,
						text: item.lastMessage
					}
				}
				else if (msgType == "first") {
					this.expandMessageItem = {
						author: item.messageAuthor,
						date: item.messageDate,
						text: item.message
					}
				}
				else {
					this.expandMessageItem = null;
					return;
				}
				this.showExpandMessageDialog = true;
			},
			seenSwitch(item) {
				let count = this.calcNewMessagesCount(item.npp);
				if (count != 0) {
					if (count > 1) {
						this.openTicket(item.number, item.npp);
					}
					else {
						this.setMessageSeen(item, true);
					}
				}
				else {
					this.setMessageSeen(item, false);
				}
			},
			setMessageSeen(item, seen) {
				let params = {
					ticketId: item.npp,
					messageId: item.lastMessageId,
					seen: seen,
					clientId: this.CURRENTAPTEKA.npp,
					userId: this.CURRENTUSER.userId
				}
				item.switchDisabled = true;
				this.$http.post("data/SetTicketMessageSeen", params, {emulateJSON: true})
				.then(
					() => {
							this.$emit('seenStateChanged');
							item.switchDisabled = false;
						}
				).catch(
					(response) => {
						item.switchDisabled = false;
					}
				)
			},
			hasSiteUsers() {
				return this.SITEUSERS.length > 0;
			}
		},
		computed: {
			...mapGetters([
				"LAST_NUMBER",
				"TICKETS",
				"OPENEDTICKETSTABS",
				"SUPPORTTABS",
				"TICKETSINPUTDATA",
				"TICKETSFIRSTLOAD",
				"TICKETSSTATES",
				// "TICKETSCLIENTS",
				"TICKETSFILTERSTATES",
				"TICKETSFILTERCLIENTS",
				"CURRENTAPTEKA",
				'CURRENTUSER',
				// "TICKETSLISTLASTUPDATETIME",
				"TICKETSWITHCHANGES",
				// 'TICKETSWITHUSERMESSAGES',
				'SITEUSERS',
				'ISRESPONSEREQUESTTICKETS',
				'TICKETSFILTERUSERSOFAPTEKA'
			]),
			newTicketInProcess :{
				get() {
					let tabs = this.SUPPORTTABS;
					for (let i = 1; i < tabs.length; i++) {
						if (!tabs[i].Number) {
							return true;
						}
					}
				}
			},
			localInputData: {
				get() {
					return this.TICKETSINPUTDATA;
				},
				set(value) {
					this.$store.dispatch("SET_TICKETSINPUTDATA", value);
				}
			},
			loading: {
				get() {
					return this.getLoading();
				},
				set(value) {
					this.setLoading(value);
				}
			},
			paramsData() {
				let rowsPerPage = this.getRowsPerPage();
				let currentPage = this.getCurrentPage();
				return {
					filterStates: this.fltStates,
					filterClients: this.fltClients,
					row_num_begin: (currentPage - 1) * rowsPerPage + 1,
					row_num_end: currentPage * rowsPerPage,
					apteka_npp: this.CURRENTAPTEKA.npp,
					userId: this.calcSelectedUsersOfApteka
				};
			},
			fltStates: {
				get() {
					return this.TICKETSFILTERSTATES;
				},
				set(value) {
					this.$store.dispatch("SET_TICKETSFILTERSTATES", value);
				}
			},
			fltClients: {
				get() {
					return this.TICKETSFILTERCLIENTS;
				},
				set(value) {
					this.$store.dispatch("SET_TICKETSFILTERCLIENTS", value.trim());
				}
			},
			fltUsersOfApteka: {
				get() {
					return this.TICKETSFILTERUSERSOFAPTEKA;
				},
				set(value) {
					this.$store.dispatch("SET_TICKETSFILTERUSERSOFAPTEKA", value);
				}
			},
			calcSelectedUsersOfApteka() {
				// return this.fltUsersOfApteka.length ? this.fltUsersOfApteka.join() : this.SITEUSERS.map(x => x.id).concat(0).join();
				return this.fltUsersOfApteka.length ? this.fltUsersOfApteka.join() : '';
			},
			debounceClickUpdate() {
				return debounce(() => {
					// console.log('onInputFilter');
					this.clickUpdate();
				}, 1000);
			},
			userId() {
				return this.CURRENTUSER.hasOwnProperty('userId') ? this.CURRENTUSER.userId : 0;
			}
			// tableHeight: {
			// 	get() { return this.$store.state.app.tableHeight; },
			// 	set(value) { this.$store.dispatch('setApp', { 'tableHeight': value }); }
			// }
		},
		created() {
			//console.log('created tickets');
			this.$root.$on("SUPPORTUPDATE", this.update);
			this.$root.$on("show-ticket", this.openTicket);
		},
		updated() {
			//console.log('updated tickets');
		},
		beforeUpdate() {
			//console.log('beforeUpdate tickets');
		},
		mounted() {
			
			// console.log('mounted tickets');
			//подписка на событие расчета высоты таблицы
			this.$root.$on('calcTicketsTableHeight', this.calcTableHeight);

			//список статусов заявок
			if (this.TICKETSSTATES.length === 0)
				this.$store.dispatch("GET_TICKETS_STATES");


			//список клиентов
			// if (this.TICKETSCLIENTS.length == 0)
			// 	this.$store.dispatch("GET_TICKETS_CLIENTS");

			//устанавливаем данные для пагинации
			if (this.TICKETSFIRSTLOAD === true) {
				this.$store.dispatch("SET_TICKETSFIRSTLOAD", false);
				this.setCurrentPage(1);
				// this.update(); // данные загружаются из MainSupport по событию SUPPORTUPDATE
			} else {
				//   this.localInputData = this.TICKETSINPUTDATA;
				this.loading = true;
				this.setParentCountPagination();
				window.setTimeout(this.clearLoading, 500);
			}
			this.update();

			//расчет высоты таблицы
			this.calcTableHeight();

			this.isMounted = true;
		},
		beforeDestroy: function () {
			// console.log("tickets beforeDestroy");
			this.$root.$off("SUPPORTUPDATE", this.update);
			this.$root.$off('calcTicketsTableHeight', this.calcTableHeight);
			this.$store.dispatch("SET_TICKETSINPUTDATA", this.localInputData);
		},
		beforeRouteUpdate(to, from, next) {
			//console.log('beforeRouteUpdate');
		},
		watch: {}
	};
</script>

<style lang="scss" scoped>
		.md-content {
				padding: 10px;
		}

		.md-table-Tickets {
				margin: 0 !important;
		}

		a:hover {
				cursor: pointer;
		}

		button {
				padding: 5px;
		}

		.fadeEditTheme-enter-active, .fadeEditTheme-leave-active {
				transition: opacity .5s;
		}

		.fadeEditTheme-enter, .fadeEditTheme-leave-to {
				opacity: 0;
		}

		.message-button {
			background: transparent;
			border: transparent;
			text-align: left;
			cursor: pointer;
			border-radius: 5px;
		}
		.message-button:hover {
			background: rgba(0, 0, 0, 0.05);
		}
		.s-table {
			width: 100%;
			border-collapse: collapse;
			background-color: white;
			counter-reset: rowNumber;
			counter-increment: rowNumber;
			.table-header {
				top: 0;
				position: sticky;
				font-weight: 700;
				color: rgba(0, 0, 0, 0.54);
				z-index: 100;
				font-size: 10pt;
				text-align: start;
				height: 50px;
			}
			.table-header-filled {
				position: sticky;
				top: 0;
				background-color: white;
				z-index: 200;
			}
			.selected-row {
				background-color: #448aff;
				color: white;
				.md-button {
				color: white;
				}
			}
			.md-button {
				max-height: 28px;
			}
			td {
				font-size: 10pt;
				padding-right: 10px;
			}
			th {
				border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			}
			tr {
				border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			}
		}
		.s-table-bordered {
			td {
				border-right: 1px solid rgba(0, 0, 0, 0.1);
			}

			th {
				border-right: 1px solid rgba(0, 0, 0, 0.1);
			}
		}

		.s-table.high-rows-table td {
			font-size: 10pt;
			padding-right: 10px;
			padding-top: 10px;
			padding-bottom: 10px;
		}
		.text-td {
			vertical-align: top;
		}
		.no-padding-td {
			padding-right: 0px !important;
		}
		.badget-item {
			display: flex;
			align-content: space-between;
			.md-badge-content{	
				margin-bottom: 14px;
			}
		}
		.blinking-item {
			animation: badgeblink 2s infinite;
		}
		@keyframes badgeblink {
			from {opacity: 1;}
			50% {
				opacity: 0;
			}
			to {opacity: 1;}
		}
		#tickets-table-toolbar {
			background: white;
			box-shadow: none;
		}
		.table-card {
			margin: 0;
		}
		.title-dialog {
			margin-left: auto;
			margin-right: auto;
			max-width: 80%;
			transition: none !important;
		}
		.header-radio {
			cursor: pointer;
		}
		.table-pre {
			margin: 0px;
			white-space: pre-wrap;
		}
		.dialog-pre {
			white-space: pre-wrap;
		}
</style>
<style lang="css">
		.title-dialog .md-dialog-container {
			height: auto;
		}

		.md-table-cell-container {
				padding: 0 10px;
		}

		.icon-column .md-table-cell-container {
				padding: 0;
				width: 24px;
				/*max-width: 24px;*/
				margin: auto;
		}

		th.md-table-head {
				text-align: left;
		}

		.theme-column .md-table-cell-container {
				padding-left: 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
		}

		.theme-column .md-badge {
				right: -20px;
				top: -10px;
		}

		.theme-column span {
				color: #448AFF;
				padding: 5px 0;
				max-width: 85%;
		}

		.theme-column span:hover {
				cursor: pointer;
		}

		/*.icon-column .md-table-cell-container i:hover {*/
		/*		cursor: pointer;*/
		/*}*/

		.md-table-head-label {
				padding: 0 0 0 10px;
		}

		.md-table-fixed-header {
				width: 100%;
		}

		.last-message-dialog .md-dialog-container {
			min-width: 0px;
			min-height: 0px;
			height: auto;
			width: auto;
		}
		.last-message-dialog-text {
			margin: 5px;
		}
		.open-button {
			width: 60px;
			min-width: auto;
			margin-left: 7px !important;
			margin-right: 2px;
    		padding: 0px !important;
			font-size: 8pt !important;	
		}
		.button-grid-container {
			display: flex;
			flex-direction: row;
		}
		.title-card {
			padding-left: 5px;
			padding-right: 5px;
			overflow-y: auto;
		}
		.stars-icon {
			color: gold !important;
		}
		.stars-container {
			font-size: 0px;
			float: right;
			margin-right: -10px;
		}
</style>



// WEBPACK FOOTER //
// Components/supportNew/tickets.vue